<template>
    <section class="marquee deposit-tab">
        <div class="container">
            <div class="deposit-outer">
                <div class="fast-bank-deposit b-contant">
                    <div class="back-btn p-al">
                        <a @click="$router.go(-1)" class="back-btn-lef">
                            <img src="@/assets/images/left-arrow-bg.png" alt="" />
                            {{ $t('back', 'Back') }}
                        </a>
                        <span class="bank-deps">{{ $t('bank-details', 'Bank Details') }}</span>
                    </div>
                </div>
                <div class="deposit-outer-body b-acc pt-0">
                    <div class="pass-form mess-inner select_bank_wrapper_main">
                        <form action="">
                            <template v-if="type === 'bank'">
                                <div v-if="!isEditMode" class="input-area-wrap input-area-box">
                                    <label>{{ $t('payment-method', 'Payment Method') }} <span class="text-danger">*</span></label>
                                    <div class="dropdown bank-dropdown" v-if="filteredBankList">
                                        <button class="bank-dropdown-input" @click="clearSearchBank" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                        <span class="asterisk" >{{  selectedBank ? selectedBank : $t('select-bank-name', 'Select Bank Name') }}</span>
                                        </button>
                                        <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                            <div class="search-input">
                                                <input type="search" v-model="searchBank" class="form-control" placeholder="Search Banks...">
                                            </div>
                                            <li v-for="(item, index) in filteredBankList" :key="index" v-if="filteredBankList && filteredBankList.length">
                                                <a class="dropdown-item" @click="selectBank(item)">{{ item.bank_name }}</a>
                                            </li>
                                            <li v-else>
                                                <a class="dropdown-item">{{$t('no-data-found','No data found')}}</a>
                                            </li>
                                        </ul>
                                    </div>
                                    <p v-if="v$.accountForm.bankId.$error" class="req-pass" >{{ $t('please-select-bank-name', 'Please Select Bank Name') }}</p>
                                </div>
                                <div class="input-area-wrap input-area-box  mt-1">
                                    <label>{{ $t('account-holder-name', 'Account Holder’s Name') }} <span class="text-danger">*</span></label>
                                    <fieldset class="textfield for ">
                                        <input v-model="accountForm.holderName" class=" form-control add" type="text"  >
                                        <span class="asterisk" v-if="!accountForm.holderName">{{ $t('enter-account-holder-name', 'Enter Account Holder Name') }}</span>
                                    </fieldset>
                                    <template v-if="v$.accountForm.holderName.$error">
                                    <div v-if="v$.accountForm.holderName.required.$invalid" class="req-pass" for="nameInput">{{ $t('account-holder-name-is-required', 'Account holder name is required') }}</div>
                                    <span v-else-if="v$.accountForm.holderName.minLength.$invalid || v$.accountForm.holderName.maxLength.$invalid" class="req-pass" for="nameInput">
                                        {{ $t('min-characters','Account holder name must be 3-100 characters.') }}
                                    </span>
                                    <span v-if="v$.accountForm.holderName.alphaName.$invalid" class="req-pass" for="nameInput">
                                        {{ $t('only-letters','Must contain only alphabets, spaces, dots, or hyphens.') }}
                                    </span>
                                </template>
                                </div>
                                
                                <div class="input-area-wrap input-area-box">
                                    <label>{{ $t('ac-number', 'A/C Number') }} <span class="text-danger">*</span></label>
                                    <fieldset class="textfield">
                                        <input v-model="accountForm.accountNumber" type="tel" class="add form-control" @input="accountForm.accountNumber = accountForm.accountNumber.replace(/\D/g, '')"/>
                                         <span class="asterisk" v-if="!accountForm.accountNumber">{{ $t('enter-ac-Number', 'Enter A/C Number') }} </span>
                                    </fieldset>
                                     <template v-if="v$.accountForm.accountNumber.$error">
                                    <div v-if="v$.accountForm.accountNumber.required.$invalid" class="req-pass" for="nameInput">{{ $t('ac-number-is-required', 'Account Number is required') }}.</div>
                                    <span v-if="v$.accountForm.accountNumber.accountNoValidator.$invalid" class="req-pass" for="nameInput">
                                        {{ $t('invalid-account-number','Account number must be valid numeric value between 9 to 18 digits.') }}
                                    </span>
                                </template>   
                                </div>
                                
                                <div class="input-area-wrap input-area-box">
                                    <label>{{ $t('ifsc-code', 'IFSC Code') }} <span class="text-danger">*</span></label>
                                    <fieldset class="textfield">
                                        <input v-model="accountForm.ifscCode" class="add form-control" type="text"   />
                                        <span class="asterisk" v-if="!accountForm.ifscCode">{{ $t('enter-ifsc-code', 'Enter IFSC Code') }}</span>
                                    </fieldset>
                                    <template v-if="v$.accountForm.ifscCode.$error">
                                    <div v-if="v$.accountForm.ifscCode.required.$invalid" id="ifscCodeInput-error" class="req-pass" for="ifscCodeInput">{{ $t('ifsc-code-is-required', 'IFSC code is required') }}.</div>
                                    <span v-if="v$.accountForm.ifscCode.ifscValidator.$invalid" class="req-pass" for="nameInput">
                                        {{ $t('invalid-ifsc','IFSC code should be 11 Alphanumeric Characters') }}
                                    </span>
                                </template> 
                                </div>
                            </template>
                            <template v-if="type === 'upi' || type === 'wallet'">
                                <div class="input-area-wrap input-area-box">
                                    <label>{{ $t('account-holder-name', 'Account Holder’s Name') }} <span class="text-danger">*</span></label>
                                    <fieldset class="textfield">
                                        <input v-model="accountForm.holderName" class=" add form-control" type="text"  />
                                        <span class="asterisk" v-if="!accountForm.holderName">{{ $t('enter-account-holder-name', 'Enter Account Holder Name') }} </span>
                                    </fieldset>
                                    <p v-if="v$.accountForm.holderName.$error" class="req-pass">{{ $t('please-enter-account-holder-name', 'Please Enter Account Holder Name') }}</p>
                                </div>

                                <template v-if="type === 'upi'">
                                    <div class="input-area-wrap input-area-box">
                                        <label>{{ $t('upi-id', 'UPI ID') }}</label>
                                        <fieldset class="textfield">
                                            <input v-model="accountForm.upiId" class="add form-control" type="text"  @input="accountForm.upiId = $helper.sanitizeDetails('onlySpace',accountForm.upiId)" />
                                            <span class="asterisk" v-if="!accountForm.upiId">{{ $t('enter-upi-id', 'Enter UPI ID')}}</span>
                                        </fieldset>
                                        <div class="req-pass" v-if="accountForm.upiId != '' && v$.accountForm.upiId.$error && v$.accountForm.upiId.minLength.$invalid || v$.accountForm.upiId.maxLength.$invalid">
                                            {{  $t('upi-length','UPI ID must be 5 to 50 characters.') + $t('upi-format',' Must be in the format of name@bank.')  }}
                                        </div>
                                    </div>
                                </template>
                                
                                <template v-if="type === 'wallet'">
                                    <div class="input-area-wrap input-area-box">
                                        <label>{{ $t('wallet-id', 'Wallet ID') }} <span class="text-danger">*</span></label>
                                        <fieldset class="textfield">
                                            <input v-model="accountForm.walletId" class=" add form-control" type="text" />
                                            <span class="asterisk" v-if="!accountForm.walletId">{{ $t('enter-wallet-id', 'Enter wallet ID') }}</span>
                                        </fieldset>
                                         <template v-if="v$.accountForm.walletId.$error">
                                        <div class="req-pass" v-if="v$.accountForm.walletId.required.$invalid">{{ $t('wallet-id-is-required', 'Wallet ID is required') }}</div>
                                        <span class="req-pass" v-if="v$.accountForm.walletId.minLength.$invalid || v$.accountForm.walletId.maxLength.$invalid">{{ $t('upi-length','Wallet ID must be 8 to 20 characters.') }}</span>
                                        <span class="req-pass" v-if="v$.accountForm.walletId.walletValidator.$invalid">{{ $t('wallet-format','Must contain only letters, numbers, @, hyphens, or underscores.') }}</span>
                                    </template>
                                    </div>
                                </template>

                                <div class="number-header col-12">
                                    <h5 class="mb-1 info-sec add_bank_tooltips">{{ $t('qr-code-upload-screenshot', 'QR Code (Upload Screenshot)') }} 
                                        <span class="info-sec-icon">
                                            <img src="@/assets/images/info-icon.webp" alt="info-icon" loading="lazy">
                                            <div class="info-list">
                                                <ul>
                                                    <li>1. {{ $t('tap-your-profile', 'Upload a screenshot of a valid QR code to proceed') }}.</li>
                                                    <li>2. {{ $t('tap-qr-code', 'If QR code is not detected, Exchange will not be responsible for the losses') }}.</li>
                                                </ul>
                                            </div>
                                        </span>
                                    </h5>
                                    <div class="input-area-wrap input-area-box uplode-img" v-if="!previewImage">
                                        <div class="deposit-bg-border add_bank_file_upload_sec">
                                            <input type="file" @change="fileUpdateFunc" accept=".png, .jpg, .jpeg, .webp" class="uplode-img-input"   />
                                            <div class="deposit-bg-img">
                                                <div class="downlodw-area">
                                                    <div class="downlodw-title_main">
                                                        <span>Choose File</span>
                                                    </div>
                                                    <div class="text-file-messege">
                                                        <span class="uplode-text">{{ $t('upload', 'No Choosen File') }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- <p v-if="v$.accountForm.file.$error" class="req-pass">{{ $t('please-upload-a-file', 'Please Upload a File') }}</p> -->
                                    </div>
                                    <div class="deposit-bg-border" v-if="previewImage">
                                        <div class="deposit-uploaded">
                                            <div class="customPreview">
                                                <img :src="previewImage" alt="cross-icon" loading="lazy">
                                            </div>
                                            <button class="deletPreview" @click="clearPaymentSlip()">
                                                <img src="@/assets/images/cross.svg" alt="">
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </template>
                             <div class="input-area-wrap input-area-box withdraw_password_icon12" > 
                                    <label for="nameInput">{{ $t('withdrawal-password', 'Withdrawal Password') }} <span class="text-danger">*</span></label>
                                        <fieldset class="textfield">
                                            <input :type="passwordFieldType" v-model="accountForm.withdrawal_password" @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password, 20)" class="textfield__input" :class="{'add form-control':!accountForm.withdrawal_password}"   />
                                            <span class="asterisk" v-if="!accountForm.withdrawal_password">{{ $t('enter-withdraw-password', 'Enter Withdraw Password') }}</span>
                                            <div @click="togglePasswordVisibility('passwordField')">
                                                <img class="hide_show_pass12" v-if="passwordFieldType === 'password'" src="@/assets/images/hide-pasword.webp" alt="show-pass" loading="lazy"/>
                                                <img class="hide_show_pass12" v-else src="@/assets/images/show-pasword.webp" alt="show-pass"  loading="lazy"/>
                                            </div>
                                        </fieldset>
                                        <p v-if="v$.accountForm.withdrawal_password.$error" class="req-pass">{{ $t('please-enter-withdraw-password', 'Please Enter Withdraw Password') }}</p>
                                    </div>


                            <!-- <div class="customer-form">
                                <span>{{ $t('for-security-reasons-withdrawal-is-only-allowed-to', 'For security reasons, withdrawal is only allowed to account owner. If you have any issues, do not hesitate to contact our') }}</span>
                                <a class="customer">{{ $t('customer-service', 'Customer Service') }}.</a>
                            </div> -->
                            <div class="add-acc pb-1 add_reset_btn" v-if="isEditMode">
                                <button type="button" class="btn-sum Reast-btn w-50" @click="$router.go(-1)">{{ $t('cancel', 'Cancel') }}</button>
                                <button type="button" class="btn-sum add-btn w-50" @click="addAccountServiceCall()">{{ $t('update','Update')}}</button>
                            </div>
                            <div class="add-acc pb-1 add_reset_btn" v-else>
                                <button type="button" class="btn-sum Reast-btn w-50" @click="resetForm()">{{ $t('reset', 'Reset') }}</button>
                                <button type="button" class="btn-sum add-btn w-50" @click="addAccountServiceCall()">{{ $t('add-account', 'Add account') }}</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    <div class="modal fade withdraw-password-continue" id="cancelbetModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
            data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header headerTheme">
                        <h5>{{$t('withDraw-password','Withdraw password')}}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <i class="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="account-delete-msg">
                            <p>{{$t('skip-msg','Withdraw password not set. Continue to add or skip')}}..!!</p>
                        </div>
                        <div class="header-but  info-footer">
                            <button type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal" @click="addAccountServiceCall(true)">{{ $t('skip','Skip') }}</button>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
import { required, minLength, maxLength, helpers } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';
import { defineAsyncComponent } from 'vue';
import { addAccount} from "../services/withdrawAccountDetails"
const alphaName = helpers.withMessage(
  'Must contain only alphabets, spaces, dots, or hyphens.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    const s = String(value)
    return /^[A-Za-z .-]+$/.test(s)
  }
)
const accountNoValidator = helpers.withMessage(
  'Account number must be valid numeric value between 9 to 18 digits.',
  (value) => {
    if (!value) return true
    return /^[0-9]{9,18}$/.test(String(value))
  }
)
const ifscValidator = helpers.withMessage(
  "Invalid IFSC Code format. It should be 11 alphanumeric characters.",
  (value) => {
    if (!value) return true;
    return /^[a-zA-Z0-9]{11}$/.test(String(value))
  }
)
const walletValidator = helpers.withMessage(
  'Must contain only letters, numbers, hyphens, or underscores.',
  (value) => {
    if (value === null || value === undefined || value === '') return true
    return /^[A-Za-z0-9_@-]+$/.test(String(value))
  }
)
export default {
    name: "AddAccount",
    inject:['walletConfig'],
    setup() {
		return { v$: useVuelidate() }
	},
    data() {
        return {
            loading: false,
            amount: null,
            bankDetailsList: [],
            type: null,
            errors: {},
            accountForm: {
                accountId: '',
				bankId: null,
				holderName: '',
				accountNumber: '',
				ifscCode: '',
				upiId: '',
				walletId: '',
				file: null,
                withdrawal_password: null

			},
            isEditMode: this.mode == 'edit',
            searchBank:null,
            selectedBank:null,
            previewImage: null,
            paymentType: null,
            passwordFieldType: 'password',
        }
    },
    props: ['mode'],
    computed: {
        isEditMode() {
            return this.mode == 'edit';
        },
        filteredBankList() {         
            if(this.searchBank) {
                const searchTermLower = this.searchBank?.toLowerCase();
                return this.bankDetailsList?.filter(item => item?.bank_name?.toLowerCase().includes(searchTermLower));
            }
            return this.bankDetailsList
        }
    },
    validations() {
        return {
            accountForm: {
                bankId: this.type === 'bank' ? { required } : {},
                holderName: { 
                    required,
                    minLength: minLength(3),
                    maxLength: maxLength(100),
                    alphaName
                },
                accountNumber: this.type === 'bank' ? { 
                    required,
                    accountNoValidator
                } : {},
                ifscCode: this.type === 'bank' ? { 
                    required,
                    ifscValidator
                } : {},
                upiId: this.type === 'upi' ? {
                    minLength: minLength(5),
                    maxLength: maxLength(50)
                } : {},
                walletId: this.type === 'wallet' ? { 
                    required,
                    minLength: minLength(8),
                    maxLength: maxLength(20),
                    walletValidator    
                } : {},
                withdrawal_password: { required },

            }
        };
    },
    mounted() {
        this.bankDetailsList = this.walletConfig?.bank_list
        this.paymentType = this.$store?.getters?.selectedPayementType;
        this.isEditMode = this.paymentType?.method_type && this.paymentType?.id ? true : false;

        if(this.paymentType.method_type == 'bank') {
            this.updateBankDetails(this.paymentType);
        } else if(this.paymentType.method_type == 'upi') {
            this.updateUpiDetails(this.paymentType);
        } else if(this.paymentType.method_type == 'wallet') {
            this.updateWalletDetails(this.paymentType);
        }
        this.accountId = this.paymentType?.id;
        this.type = this.paymentType.method_type;
        this.accountForm.paymentMethodId = this.paymentType.id;
        this.accountForm.paymentTypeName = this.paymentType.method_name;
    },
    methods: {
        clearPaymentSlip() {
            this.previewImage = null;
            this.accountForm.file = undefined;
        },
        clearSearchBank(){
            this.searchBank = ''
        },
        selectBank(item){
            this.accountForm.bankId = item.id
            this.selectedBank = item.bank_name
            this.searchBank = ''
        },
        updateBankDetails(paymentType) {
            this.accountForm = {
                    accountId: paymentType.id,
                    holderName: paymentType.account_holder_name,
                    accountNumber: paymentType.account_number,
                    ifscCode: paymentType.ifsc_code,

            }
        },
        updateUpiDetails(paymentType) {
            this.accountForm = {
                accountId: paymentType.id,
				holderName: paymentType.account_holder_name,
				upiId: paymentType.upi_id,
				file: null
			}
        },
        updateWalletDetails(paymentType) {
            this.accountForm = {
                accountId: paymentType.id,
				holderName: paymentType.account_holder_name,
				walletId: paymentType.wallet_id,
				file: null
			}
        },
        resetForm() {
            this.accountForm = {
                bankId: null,
                holderName: '',
                accountNumber: '',
                ifscCode: '',
                upiId: '',
                walletId: '',
                file: null
            };
            this.selectedBank = null
            this.searchBank = null
            this.v$.$reset();
            this.clearPaymentSlip()
        },
        getBankFields() {
            const bank = this.bankDetailsList.find(item => item.id === parseInt(this.accountForm.bankId));
            this.ifsc = bank?.country?.toLowerCase() === 'india';
        },
        fileUpdateFunc(event) {
            try {
                const file = event.target.files[0];                
                if (!file) return;
                const allowedTypes = ['image/jpeg', 'image/png', 'image/webp'];
                if (!allowedTypes.includes(file.type)) {
                    this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                    this.previewImageUtr = null;
                    return;
                }
                const maxSize = 5 * 1024 * 1024; 
                if (file.size > maxSize) {
                    this.$errorToast('Invalid file type. Only JPG, JPEG, PNG, and WEBP image formats are allowed, and file size must be under 5 MB.');
                    return;
                }
                this.accountForm.file = event.target.files[0];
                this.previewImage = URL.createObjectURL(this.accountForm.file);
            } catch(e) {
                console.log(e);
                
                this.$errorToast(this.$t('try-again-with-different-image', 'Try again with different image!'));
            }
        },
        async addAccountServiceCall() {  
            this.v$.$touch()
            if (this.v$.$error) {
                return
            } else {
                if(this.type === 'upi' && this.accountForm.upiId == '' && this.accountForm.file == null){
                    this.$errorToast('At least one field is required UPI ID or QR code.')
                    return false;
                }
                // const selectedItem = this.paymentMethodList.find(item => item.id === this.paymentMethodId);
                let response = await addAccount(this.paymentType, this.type, this.accountForm, this.accountForm)
                if(response){
                    // this.clearError();
                    this.$successToast(response?.data?.message);
                    this.$router.push({ name: 'bank-details' });
                }
            }
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
    }
}
</script>
<style scoped>
.bank-dropdown {
  position: relative;
  margin-bottom: 5px;
}
.bank-dropdown-btn {
  position: relative;
  display: block;
  width: 100%;
  padding: 0 !important;
  border-radius: 0;
  border: none !important;
  background: transparent !important;
  outline: none !important;
}
.bank-dropdown-input {
  transition: all .15s ease-in-out, box-shadow .15s ease-in-out;
  text-align: left;
  display: inline-block;
  padding: 10px 38px 10px 10px;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: .25rem;
  width: 100%;
  font-feature-settings: inherit;
  font-size: 14px;
  font-variation-settings: inherit;
  font-weight: inherit;
  letter-spacing: inherit;
  line-height: 1.5;
  color: #000;
  outline: none !important;
  background-color: #fff;
  background-image: url("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right .75rem center;
  background-size: 16px 12px;
  height: 40px;
}
.bank-dropdown-input:focus {
  border-color: var(--green-color);
}
.bank-dropdown .search-input {
  background-color: #fff;
  padding: 5px;
}
.bank-dropdown .dropdown-menu {
  margin-top: .125rem !important;
  position: absolute;
  max-height: 280px;
  width: 100%;
  overflow-y: auto;
  border-radius: .25rem;
  border: 1px solid #ced4da;
  background-color: #f3f4f6;
  box-shadow: var(--tw-ring-offset-shadow,0 0 #0000),var(--tw-ring-shadow,0 0 #0000),var(--tw-shadow);
  transition-duration: .3s;
  transition-duration: .15s;
  transition-property: all;
  transition-timing-function: cubic-bezier(.4,0,.2,1);
  padding: 0px;
  inset: 100% auto auto 0 !important;
  transform: none !important;
}
.bank-dropdown .dropdown-menu li {
  padding: 0px;
  margin: 0px;
}
.bank-dropdown .dropdown-menu .dropdown-item {  
  padding: 4px 6px;
  cursor: pointer;
  border-bottom: 1px solid #ced4da;
  color: #000;
  line-height: 1.5;
  font-size: .875rem;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.bank-dropdown .dropdown-menu .dropdown-item.active {
  font-weight: 600;
  color: #fff;
  background-image: linear-gradient(95deg,#6e081d -8.6%,#c10931 110.45%);
}
.input-area-box span{
    display:inline !important
}
.withdraw_password_icon12>a{
    color:#0d6efd !important;
    text-decoration: underline;
    cursor: pointer;
}
.textfield .form-control, .textfield .form-select{
    min-height: 35px;
    letter-spacing: 0;
    font-size: .8rem;
    color: #3e3999;
    position: relative;
    background: transparent;
    z-index: 2;
}
.textfield__input{
    min-height: 35px;
    letter-spacing: 0;
    font-size: .8rem;
    color: #3e3999 !important;
    position: relative;
    background: transparent;
}
.bank-dropdown .dropdown-menu .dropdown-item{
    color:#fff !important;
    background:#000 !important;
}
</style>